// // src/hooks/useCollabRotation.js
// import * as Y from "yjs";
// import { WebsocketProvider } from "y-websocket";
// import { useEffect, useRef } from "react";

// /**
//  * Same shape as your other hooks:
//  *   const { syncRotation } = useCollabRotation(projectId, (remoteAngle) => { ... });
//  * The remote callback receives a single absolute number (0..359).
//  */
// export default function useCollabRotation(projectId, onRemoteAngle) {
//   const ydocRef = useRef(null);
//   const providerRef = useRef(null);
//   const yMapRef = useRef(null);

//   useEffect(() => {
//     if (!projectId) return;

//     const ydoc = new Y.Doc();
//     const provider = new WebsocketProvider(
//       process.env.REACT_APP_SOCKET_URL || "ws://localhost:1234",
//       String(projectId),
//       ydoc
//     );

//     const yMap = ydoc.getMap("rotation");

//     const observer = () => {
//       const angle = yMap.get("angle");
//       if (typeof angle === "number") onRemoteAngle?.(angle);
//     };

//     yMap.observe(observer);
//     // hydrate once on join
//     observer();

//     ydocRef.current = ydoc;
//     providerRef.current = provider;
//     yMapRef.current = yMap;

//     return () => {
//       try {
//         yMap.unobserve(observer);
//       } catch {}
//       try {
//         provider.destroy();
//       } catch {}
//       try {
//         ydoc.destroy();
//       } catch {}
//       ydocRef.current = null;
//       providerRef.current = null;
//       yMapRef.current = null;
//     };
//   }, [projectId, onRemoteAngle]);

//   const syncRotation = (absoluteAngle) => {
//     const m = yMapRef.current;
//     if (!m) return;
//     const a = ((Number(absoluteAngle) % 360) + 360) % 360; // 0..359
//     m.set("angle", a);
//   };

//   return { syncRotation };
// }

// src/hooks/useCollabRotation.js
import * as Y from "yjs";
import { WebsocketProvider } from "y-websocket";
import { useEffect, useRef } from "react";

/**
 * Same public API:
 *   const { syncRotation } = useCollabRotation(projectId, (remoteAngle) => {...});
 */
export default function useCollabRotation(projectId, onRemoteAngle) {
  const ydocRef = useRef(null);
  const providerRef = useRef(null);
  const yMapRef = useRef(null);

  // NEW: keep the callback stable across renders
  const onRemoteAngleRef = useRef(onRemoteAngle);
  useEffect(() => {
    onRemoteAngleRef.current = onRemoteAngle;
  }, [onRemoteAngle]);

  useEffect(() => {
    if (!projectId) return;

    const ydoc = new Y.Doc();
    const provider = new WebsocketProvider(
      process.env.REACT_APP_SOCKET_URL || "ws://localhost:1234",
      String(projectId),
      ydoc
    );

    const yMap = ydoc.getMap("rotation");

    const observer = () => {
      const angle = yMap.get("angle");
      if (typeof angle === "number") {
        // use the latest callback without recreating the provider
        onRemoteAngleRef.current?.(angle);
      }
    };

    yMap.observe(observer);
    // hydrate once on join
    observer();

    ydocRef.current = ydoc;
    providerRef.current = provider;
    yMapRef.current = yMap;

    return () => {
      try {
        yMap.unobserve(observer);
      } catch {}
      try {
        provider.destroy();
      } catch {}
      try {
        ydoc.destroy();
      } catch {}
      ydocRef.current = null;
      providerRef.current = null;
      yMapRef.current = null;
    };
  }, [projectId]); // ⟵ IMPORTANT: no onRemoteAngle dependency

  const syncRotation = (absoluteAngle) => {
    const m = yMapRef.current;
    if (!m) return;
    const a = ((Number(absoluteAngle) % 360) + 360) % 360; // 0..359
    m.set("angle", a);
  };

  return { syncRotation };
}
